import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../../services/toast.service';

const NO_PERMISSIONS_ERROR = 'You do not have sufficient permissions to perform this request.';
const NOT_AUTHENTICATED_ERROR = 'You are not authenticated. Please sign in again.';
const TASK_NOT_ASSIGNED_REASON = 'task_not_assigned';
const TASK_NOT_ASSIGNED_ERROR = 'This task is not assigned to you.';

export function permissionsInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        const detail = error.error?.detail;
        const errorMessage = typeof detail === 'string'
          ? detail
          : typeof detail?.error === 'string'
            ? detail.error
            : detail?.reason === TASK_NOT_ASSIGNED_REASON ? TASK_NOT_ASSIGNED_ERROR : NOT_AUTHENTICATED_ERROR;
        toastService.showError(errorMessage);
      } else if (error.status === 403) {
        const detail = error.error?.detail;
        const errorMessage = typeof detail === 'string'
          ? detail
          : typeof detail?.error === 'string'
            ? detail.error
            : typeof error.error?.error === 'string'
              ? error.error.error
              : NO_PERMISSIONS_ERROR;
        toastService.showError(errorMessage);
      }
      return throwError(() => error);
    })
  );
}
